import React from 'react';
import QRCode from 'react-qr-code';
import { useHistory } from 'react-router';
import { Avatar, getFaIcon, Button } from '@odin-labs/components';
import { getCurrentDomain } from 'utils';
import { faBriefcase, ArrowLeftIcon } from 'components/icons';
import { Logo } from 'components/logo';
import { JobsiteFormSubmission } from 'containers/jobsiteFormSubmission/print/types';

export const classes = {
  container: 'odin-flex odin-items-center odin-justify-between',
  leftContainer: 'odin-flex odin-items-center odin-gap-x-3',
  rightContainer: 'odin-flex odin-items-center odin-gap-x-7',
  backButton: 'print:odin-hidden odin--ml-1',
  text: '',
};

const BriefcaseIcon = getFaIcon({
  icon: faBriefcase,
  className: 'odin-text-odin-primary',
});

export type JobsiteReportTitleProps = {
  jobsiteFormSubmission: JobsiteFormSubmission;
};

export function JobsiteReportTitle(
  props: JobsiteReportTitleProps,
): React.ReactElement {
  const { jobsiteFormSubmission } = props;
  const qrUrl = `${getCurrentDomain()}/forms/site-safety/${
    jobsiteFormSubmission.id
  }`;
  const history = useHistory();

  return (
    <div className={classes.container}>
      <div className={classes.leftContainer}>
        <Avatar size="3xl" src="" icon={BriefcaseIcon} />
        <div className="">
          <Button
            className={classes.backButton}
            text="Back"
            icon={ArrowLeftIcon}
            theme="naked"
            onClick={(): void => history.goBack()}
          />
          <h1 className={classes.text}>
            {jobsiteFormSubmission.extraData?.name}
          </h1>
        </div>
      </div>
      <div className={classes.rightContainer}>
        <Logo />
        <QRCode value={qrUrl} size={72} />
      </div>
    </div>
  );
}
